import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { SButton } from '../styles/Button.styled';

export const SModalContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 10px;
  box-shadow: 0px 10px 18px 0px rgba(157, 180, 190, 0.5);
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 722px;
`;

export const SModalBodyContainer = styled.div`
  display: block;

  .global-search-body {
    min-width: 722px;
    margin: 5px;
  }

  &.secondary-messages {
    max-width: 722px;
  }

  .search-criteria-field {
    color: ${({ theme }) => theme.colors.primaryText};
    font-size: 12.5px;
    font-family: ${({ theme }) => theme.fonts.medium};
    text-transform: none;
  }
`;

export const STopIconsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 40px 40px 25px 70px;

  .fa-xmark:hover {
    cursor: pointer;
  }
`;

export const SActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 70px 70px 60px;

  &.single {
    justify-content: flex-end;
  }

  ${SButton} {
    flex-basis: 50%;

    + ${SButton} {
      margin-left: 10px;
    }
  }
`;

interface IIsErrorProps {
  iserror?: boolean;
}

export const SModalIcon = styled.div<IIsErrorProps>`
  color: ${({ theme, iserror }) => (iserror ? theme.colors.error : theme.colors.primary)};
  font-size: 35px;
`;

export const SModalTitle = styled(Modal.Title)<IIsErrorProps>`
  font-size: 35px;
  font-weight: 600;
  line-height: 40px;
  margin-top: 20px;
  color: ${({ theme, iserror }) => (iserror ? theme.colors.error : theme.colors.primaryText)};

  &.create-copies-title {
    font-size: 20px;
    font-weight: normal;
    margin-top: 0px;
    color: ${({ theme, iserror }) => (iserror ? theme.colors.error : theme.colors.primaryText)};
  }
`;

export const SModalDescription = styled.div<IIsErrorProps>`
  color: ${({ theme, iserror }) => (iserror ? theme.colors.error : theme.colors.secondaryText)};
  font-size: 15px;
  font-weight: normal;
  letter-spacing: 0.21px;
  line-height: 20px;
  margin-top: 19px;
  margin-bottom: 30px;

  .important-description {
    font-weight: 500;
  }

  .large-description {
    color: ${({ theme }) => theme.colors.icon};
    font-size: 35px;
    line-height: 40px;
    margin-bottom: 20px;
    max-width: 500px;
  }

  .create-copies-errors {
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: auto;
    min-height: fit-content;
    max-height: 150px;
  }

  &.create-copies-description {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  p {
    margin-bottom: 0px;
  }
`;
